<script lang="ts">
    import RewardsGeneralTheme from "@apps/rewards/components/Theme/RewardsGeneralTheme.svelte";
    import type { RewardsStorefrontValuesBrandingEntity } from "@apps/rewards/modules/StorefrontValues/models/RewardsStorefrontValuesEntities";
    import { lightenColor } from "@ui-utils/lightenColor";

    //Props
    export let rewardsBranding: RewardsStorefrontValuesBrandingEntity;

    const {
        general: { theme },
    } = rewardsBranding;
</script>

<RewardsGeneralTheme rewardsBrandingGeneral={rewardsBranding.general}>
    <div
        style:--gw-rd-vip-tiers-page-widget__theme-primary-color-lighten={lightenColor(
            theme.primaryColor,
            48
        )}
    >
        <slot />
    </div>
</RewardsGeneralTheme>
